// extracted by mini-css-extract-plugin
module.exports = {"container":"searchedUser_container__eEuro","profilePicHolder":"searchedUser_profilePicHolder__1p2TI","username":"searchedUser_username__2xWVn"};